import { Image } from "../vehicleDetails/vehicle-details-dto.type";

export const addDuplicates = (images: Image[]) => {
  return [
    images[images.length - 2],
    images[images.length - 1],
    ...images,
    images[0],
    images[1],
  ];
};
